<section class="article-list mt-4">
  @if (vm$ | async; as vm) {
    @if (vm.isLoading) {
      <p class="text-sm text-text-muted">Loading collection...</p>
    } @else if (
      vm.hasError || vm.numeronCollection === null || !vm.numeronCollection.isCollection
    ) {
      <p class="text-sm text-text-muted">Collection is unavailable right now. Please try again.</p>
    } @else {
      <h1 class="mb-3 text-xl font-semibold text-text">{{ vm.numeronCollection.title }}</h1>

      @if (isStandardMode(vm.numeronCollection.type)) {
        <div appOrderedMasonry>
          @for (numeron of vm.numeronCollection.numerons; track numeron._id) {
            <div appOrderedMasonryItem>
              <app-numeron-card
                [numeron]="numeron"
                [numeronCollection]="vm.numeronCollection"
                displayMode="collection-standard"
              ></app-numeron-card>
            </div>
          }
        </div>
      } @else if (isListMode(vm.numeronCollection.type)) {
        <app-collection-list-card [collection]="vm.numeronCollection"></app-collection-list-card>
      } @else {
        <p class="text-sm text-text-muted">Unsupported collection type.</p>
      }
    }
  }
</section>
